var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0845",
    d: "M21 17.7a.8.8 0 01.1 1.594l-.1.006H3a.8.8 0 01-.1-1.594L3 17.7h18zm0-6a.8.8 0 01.1 1.594l-.1.006H3a.8.8 0 01-.1-1.594L3 11.7h18zm0-6a.8.8 0 01.1 1.594L21 7.3H3a.8.8 0 01-.1-1.594L3 5.7h18z"
  })));
}
export default SvgHamburger;